import { c as _c } from "react/compiler-runtime";
import React, { useEffect } from 'react';
import { StyledDrawer, StyledGridDrawerFooter } from './styles';
import { type NavContentItem, type SideNavigationProps } from '../../components/SideNavigation/types';
import NavHeader from './NavHeader';
import NavFooter from './NavFooter';
import NavContent from './NavContent';
const SideNavigation = t0 => {
  const $ = _c(47);
  const {
    isExpanded: t1,
    onToogleClick,
    isFooterExpanded: t2,
    navContent,
    navFooter,
    navHeader,
    navFooterActions
  } = t0;
  const isExpanded = t1 === undefined ? false : t1;
  const isFooterExpanded = t2 === undefined ? false : t2;
  const [navBarOpen, setNavBarOpen] = React.useState(isExpanded);
  const [navFooterOpen, setNavFooterOpen] = React.useState(isFooterExpanded);
  const [navList, setNavList] = React.useState(navContent.content);
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const [expandedIndexes, setExpandedIndexes] = React.useState(t3);
  const controlledByParent = onToogleClick != null;
  const open = controlledByParent ? isExpanded : navBarOpen;
  let t4;
  if ($[1] !== controlledByParent || $[2] !== onToogleClick) {
    t4 = controlledByParent ? onToogleClick : () => {
      setNavBarOpen(_temp);
    };
    $[1] = controlledByParent;
    $[2] = onToogleClick;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const toggleSideNav = t4;
  let t5;
  if ($[4] !== navContent.content) {
    t5 = () => {
      setNavList(navContent.content);
    };
    $[4] = navContent.content;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== navContent) {
    t6 = [navContent];
    $[6] = navContent;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  useEffect(t5, t6);
  let t7;
  if ($[8] !== navContent.selectedChildIndex || $[9] !== navContent.selectedIndex || $[10] !== open || $[11] !== toggleSideNav) {
    t7 = () => {
      if (open) {
        setNavFooterOpen(false);
        if (navContent.selectedChildIndex != null && navContent.selectedIndex != null) {
          setExpandedIndexes([navContent.selectedIndex]);
        } else {
          setExpandedIndexes([]);
        }
      }
      toggleSideNav();
    };
    $[8] = navContent.selectedChildIndex;
    $[9] = navContent.selectedIndex;
    $[10] = open;
    $[11] = toggleSideNav;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const handleNavBarToggle = t7;
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = index => {
      setExpandedIndexes(prev_0 => [...prev_0, index]);
    };
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const addIndexToExpandedIndexes = t8;
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = index_0 => {
      setExpandedIndexes(prev_1 => prev_1.filter(item => item !== index_0));
    };
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const removeIndexFromExpandedIndexes = t9;
  let t10;
  if ($[15] !== expandedIndexes || $[16] !== navContent.selectedIndex || $[17] !== open || $[18] !== toggleSideNav) {
    t10 = index_1 => {
      const isIndexExpanded = expandedIndexes.includes(index_1);
      if (!open) {
        toggleSideNav();
        const isClickedItemAlreadyExpanded = index_1 === navContent.selectedIndex && isIndexExpanded;
        if (isClickedItemAlreadyExpanded) {
          return;
        }
      }
      isIndexExpanded ? removeIndexFromExpandedIndexes(index_1) : addIndexToExpandedIndexes(index_1);
    };
    $[15] = expandedIndexes;
    $[16] = navContent.selectedIndex;
    $[17] = open;
    $[18] = toggleSideNav;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  const handleContentItemWithChildrenToggle = t10;
  let t11;
  if ($[20] !== navFooterOpen || $[21] !== open || $[22] !== toggleSideNav) {
    t11 = () => {
      if (!navFooterOpen && !open) {
        toggleSideNav();
      }
      setNavFooterOpen(_temp2);
    };
    $[20] = navFooterOpen;
    $[21] = open;
    $[22] = toggleSideNav;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  const handleNavFooterToggle = t11;
  const [prevSelectedIndex, setPrevSelectedIndex] = React.useState(undefined);
  if (prevSelectedIndex !== navContent.selectedIndex && navContent.selectedIndex != null) {
    setExpandedIndexes([navContent.selectedIndex]);
    setPrevSelectedIndex(navContent.selectedIndex);
  }
  let t12;
  if ($[24] !== navHeader) {
    t12 = <NavHeader {...navHeader} />;
    $[24] = navHeader;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== expandedIndexes || $[27] !== handleContentItemWithChildrenToggle || $[28] !== handleNavBarToggle || $[29] !== navContent.selectedChildIndex || $[30] !== navContent.selectedIndex || $[31] !== navList || $[32] !== open) {
    t13 = <NavContent content={navList} selectedIndex={navContent.selectedIndex} selectedChildIndex={navContent.selectedChildIndex} expandedIndexes={expandedIndexes} isNavBarOpen={open} handleNavBarToggle={handleNavBarToggle} handleContentItemWithChildrenToggle={handleContentItemWithChildrenToggle} />;
    $[26] = expandedIndexes;
    $[27] = handleContentItemWithChildrenToggle;
    $[28] = handleNavBarToggle;
    $[29] = navContent.selectedChildIndex;
    $[30] = navContent.selectedIndex;
    $[31] = navList;
    $[32] = open;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== handleNavFooterToggle || $[35] !== navFooterOpen || $[36] !== open) {
    t14 = {
      isNavBarOpen: open,
      isNavFooterOpen: navFooterOpen,
      toggleNavFooter: handleNavFooterToggle
    };
    $[34] = handleNavFooterToggle;
    $[35] = navFooterOpen;
    $[36] = open;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  let t15;
  if ($[38] !== navFooter || $[39] !== navFooterActions || $[40] !== t14) {
    t15 = <StyledGridDrawerFooter><NavFooter accountSection={navFooter} navFooterActions={navFooterActions} sideNavProps={t14} /></StyledGridDrawerFooter>;
    $[38] = navFooter;
    $[39] = navFooterActions;
    $[40] = t14;
    $[41] = t15;
  } else {
    t15 = $[41];
  }
  let t16;
  if ($[42] !== open || $[43] !== t12 || $[44] !== t13 || $[45] !== t15) {
    t16 = <nav><StyledDrawer variant="permanent" open={open}>{t12}{t13}{t15}</StyledDrawer></nav>;
    $[42] = open;
    $[43] = t12;
    $[44] = t13;
    $[45] = t15;
    $[46] = t16;
  } else {
    t16 = $[46];
  }
  return t16;
};
export default SideNavigation;
export { SideNavigation };
export type { SideNavigationProps, NavFooter, NavHeader, NavContentItem } from './types';
function _temp(prev) {
  return !prev;
}
function _temp2(prev_2) {
  return !prev_2;
}